import React, { useRef, useState } from "react";
// import utils
// import component
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";

import Table from "../../components/Table";
import { useQuery, useQueryClient } from "react-query";
import userServices from "../../services/users";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import DButton from "../../components/DButton";
import moment from "moment";
import { toast } from "react-hot-toast";
import { useDisclosure } from "@chakra-ui/react";
import DModal from "../../components/DModal";
import { formattedLevel } from "../../utils/functions";

const ColumnsSearch = [
  { key: "id", value: "الآيدي" },
  { key: "name", value: "الاسم" },
  { key: "username", value: "اسم المستخدم" },
];
const userColumns = [
  { Header: "معرف المستخدم", accessor: "id" },
  { Header: "اسم المستخدم", accessor: "username" },
  { Header: "الاسم", accessor: "name" },
  { Header: "تاريخ الانشاء", accessor: "created_at" },
  { Header: "الرصيد", accessor: "balance" },
  { Header: "الحد الأقصى للدين", accessor: "max_emergency_balance" },
  { Header: "المستوى", accessor: "level" },
  { Header: "متاح/غير متاح", accessor: "is_available" },
  { Header: "العمليات", accessor: "controls" },
];
const Index = ({ title }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentPage, setCurrentPage] = useState(0);
  const [deleteUserId, setDeleteUserId] = useState();

  const searchRef = useRef();
  const selectRef = useRef();
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get("id") || "");
  const [searchParam, setSearchParam] = useState("id");
  const queryClient = useQueryClient();
  const handleSelectChange = () => {
    setSearchParam(selectRef.current.value);
    if (searchRef.current.value.trim() !== "") {
      setSearchQuery(searchRef.current.value);
    } else {
      setSearchQuery("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault(false);
    if (searchRef.current.value.trim() !== "") {
      setSearchQuery(searchRef.current.value);
    } else {
      setSearchQuery("");
    }
    queryClient.refetchQueries("getUsers");
  };

  const { data, isLoading, error } = useQuery(
    ["getUsers", currentPage, searchParam, searchQuery],
    () =>
      userServices.getAllUsersWithSearch(
        currentPage + 1,
        searchParam,
        searchQuery
      ),
    { staleTime: Infinity }
  );
  const navigate = useNavigate();
  const editUser = (id) => {
    navigate(`/users/edit/${id}`);
  };
  const deleteUser = () => {
    onClose();
    userServices
      .deleteUser(deleteUserId)
      .then((res) => {
        toast.success("تم الحذف بنجاح");
        queryClient.refetchQueries(["getUsers"]);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          toast.error("المستخدم غير موجود");
        } else {
          toast.error("حصل خطأ ما");
        }
      });
  };
  const formattedUserData = (data) => {
    if (data.length > 0) {
      return data.map((d) => ({
        ...d,
        created_at: moment(d.created_at).format("hh:mm:ss YYYY-MM-DD"),
        is_available: d.is_available === 1 ? "متاح" : "غير متاح",
        balance: +d.balance.toFixed(6),
        max_emergency_balance: +d.max_emergency_balance.toFixed(6),
        controls: (
          <div className="flex justify-center items-center">
            <Link className="block" to={`/users/orders/${d.id}`}>
              <DButton
                bgColor="primary"
                className=" px-4 rounded-[50px_!important] text-white"
              >
                {" "}
                الطلبات
              </DButton>
            </Link>
            <Link className="block" to={`/users/${d.id}/transactions`}>
              <DButton
                bgColor="success"
                className=" px-4 rounded-[50px_!important] text-white"
              >
                {" "}
                التقارير
              </DButton>
            </Link>
            <DButton
              onClick={() => editUser(d.id)}
              bgColor="secondry"
              className=" px-4 rounded-[50px_!important]"
            >
              تعديل
            </DButton>
            <DButton
              bgColor="danger"
              className={"text-white px-4 rounded-[50px_!important]"}
              onClick={() => {
                onOpen();
                setDeleteUserId(d.id);
              }}
            >
              حذف
            </DButton>
          </div>
        ),
        level: formattedLevel(d.level),
      }));
    }
    return [];
  };
  const availableSorrundWithButton = (cell) => {
    return (
      <DButton
        className={"text-white min-w-[100px] rounded-[50px_!important]"}
        bgColor={cell.value === "متاح" ? "success" : "danger"}
      >
        {cell.render("Cell")}
      </DButton>
    );
  };
  if (error) {
    return <Navigate to="404" />;
  }
  return (
    <div className="users">
      <DModal
        isOpen={isOpen}
        onClose={onClose}
        modelType="delete"
        clickHandler={deleteUser}
        bodyText="عند حذفك لهذا السجل قد يتم حذف سجلات مرتبطة به مثل
                        الطلبات او المعاملات المالية"
      />
      <PageHeading>{title}</PageHeading>
      <DCard className={`relative ${isLoading ? "min-h-[400px]" : ""}`}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <>
            <div>
              <form
                className="flex  max-lg:justify-center   flex-wrap gap-4 "
                onSubmit={handleSubmit}
              >
                <input
                  type="text"
                  ref={searchRef}
                  className="  px-[10px] relative max-lg:py-1 max-lg:w-full  border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
                  placeholder="البحث عن  ..."
                />
                <select
                  className=" px-[10px] relative  text-gray-700   max-lg:w-full border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
                  value={searchParam}
                  ref={selectRef}
                  onChange={handleSelectChange}
                >
                  {ColumnsSearch.map((d, index) => (
                    <option className="" key={index} value={d.key}>
                      {d.value}
                    </option>
                  ))}
                </select>
                <DButton
                  bgColor="success"
                  className=" px-4 max-lg:mb-2  max-lg:w-full     text-white"
                  type="submit"
                >
                  {" "}
                  بحث
                </DButton>
              </form>
            </div>
            <Table
              totalData={data.data.data.total}
              body={formattedUserData(data.data.data.data)}
              head={userColumns}
              elements={{
                is_available: availableSorrundWithButton,
              }}
              enableSearch={false}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />{" "}
          </>
        )}
      </DCard>
    </div>
  );
};

export default Index;
